import React from 'react'
import PropTypes from 'prop-types';
import './fieldExtra.scss'

const FieldExtra = ({ error, warning, marginTop, className }) => {
  const err = error || warning

  return (err
    ? <div className={`Suc-field-extra ${className}`} style={marginTop && { marginTop }} title={err}>
      {error && <span className="Suc-error">Error:</span>}
      {warning && <span className="Suc-warning">Warning:</span>}
      {err}
    </div>
    : null)
}

FieldExtra.propTypes = {
  /** error text */
  error: PropTypes.string,
  /** warning text */
  warning: PropTypes.string,
  /** margin-top value - if needed */
  marginTop: PropTypes.string,
  /** custom classname */
  className: PropTypes.string
}

FieldExtra.defaultProps = {
  className: ''
}

export default FieldExtra
